import { SetStateAction, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../../store/hooks';
import { BasicInfoFormikModel } from '../../components/campaign-basic-info/models/basic-info-formik.model';
import { VehiclePopulationFormikModel } from '../../components/campaign-vehicle-population/models/vehicle-population-formik.model';
import { CampaignResponseModel } from '../../models/campaign-response.model';
import { populateCampaignDetailsFields } from '../../utils/populate-campaign-details-fields/populate-campaign-details-fields.util';

export const usePopulateCampaignDetailsForm = <TFormikModel>(
  isOnEdit: boolean,
  campaignId: string | undefined,
  setFormValues: (
    values: SetStateAction<TFormikModel>,
    shouldValidate?: boolean | undefined
  ) => void,
  campaignFormResponseModelToFormik: (
    data: CampaignResponseModel
  ) => TFormikModel,
  formSelector:
    | (BasicInfoFormikModel | null)
    | (VehiclePopulationFormikModel | null)
) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (isOnEdit && campaignId && !formSelector) {
      populateCampaignDetailsFields<TFormikModel>(
        dispatch,
        +campaignId,
        setFormValues,
        navigate,
        campaignFormResponseModelToFormik
      ).then();
    }
  }, [isOnEdit, campaignId]);
};
